import { axiosPlatform } from "../../../_services/axios-helper";

export const getClientsForSelectedOrganization = () => {
    return axiosPlatform().get("/client");
};

export const getClientsForParallelTestOrganization = (organizationUUID) => {
    return axiosPlatform().get("/client/organization/" + organizationUUID);
};

export const getClientsForOrganization = (organizationUUID) => {
    return axiosPlatform().get("/client/organization/" + organizationUUID);
};

export const createClient = (client) => {
    return axiosPlatform().post("/client", client);
};

export const updateClient = (client) => {
    return axiosPlatform().put("/client", client);
};

export const updateClientDatevSettings = (client) => {
    return axiosPlatform().put("/client/client-datev-settings", client);
};

export const deleteClient = (clientExternalUUID) => {
    return axiosPlatform().delete("/client/" + clientExternalUUID);
};

//old url "/client/auth/new"
export const createConnectedAuthData = (connectedAuthData) => {
    return axiosPlatform().post("/client/auth", connectedAuthData);
};

export const createConnectedAuthDataForClient = (connectedAuthData) => {
    return axiosPlatform().post("/client/auth", connectedAuthData);
};

export const updateConnectedAuthDataForClient = (connectedAuthData) => {
    return axiosPlatform().put("/client/auth", connectedAuthData);
};

export const deleteConnectedAuthDataForClient = (connectedAuthData) => {
    return axiosPlatform().delete("/client/auth", { data: connectedAuthData });
};

export const preparePaypalConnectOnboarding = (clientUUID) => {
    return axiosPlatform().post("/connect/paypal", clientUUID);
};

export const prepareDatevUOOnboarding = (request) => {
    return axiosPlatform().post("/connect/datev/" + request.consultantNumber + "/" + request.clientNumber, {});
};

export const removeDatevConnection = (request) => {
    return axiosPlatform().delete("/connect/datev/" + request.consultantNumber + "/" + request.clientNumber);
};

export const getDatevConnections = () => {
    return axiosPlatform().get("/connect/datev");
};

export const addConnectedAuthDataId = (request) => {
    return axiosPlatform().post("/client/client/auth", request);
};

export const getEbayOAuthState = (clientUUID) => {
    return axiosPlatform().get("/ebay/state?clientUUID=" + clientUUID);
};

export const searchClientsFromProd = (request) => {
    return axiosPlatform().post("/client/search-from-prod", request);
};

export const autoUpdateClientFromProd = (request) => {
    return axiosPlatform().post("/client/auto-update", request);
};
